"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
define('service/app.menu',['require','exports','module','underscore','backbone','langs','appkit/service','uikit/uikit','enquire','../config','../view/product.navigation.menu','rs/models/session','../templates','../view/products.dropdown.view'],function (require, exports, module) {
  'use strict';

  var _ = require('underscore'),
    Backbone = require('backbone'),
    langs = require('langs'),
    Service = require('appkit/service'),
    UIKit = require('uikit/uikit'),
    enquire = require('enquire'),
    config = require('../config'),
    ProductNavigationMenu = require('../view/product.navigation.menu'),
    p = langs.phrase,
    staticRoot = config.staticRoot,
    Session = require('rs/models/session'),
    Templates = require('../templates'),
    ProductsDropdown = require('../view/products.dropdown.view');
  var AppMenuService = Service.extend(_defineProperty(_defineProperty({
    inject: ['layout'],
    events: {
      authenticated: 'onAuthenticated',
      'change:distractionFreeMode': 'onChangeDistractionFreeMode',
      'user:products': 'onUserProducts',
      'change:smallScreenMode': 'onChangeSmallScreen',
      'change:menuTitle': 'setMenuTitle'
    },
    replies: {
      'resize:menu': 'doMenuResize',
      'set:distractionFreeMode': 'setDistractionFreeMode',
      'get:distractionFreeMode': 'getDistractionFreeMode',
      menuTitle: 'getMenuTitle',
      'top:menu': 'getTopMenu',
      'product:menu': 'getProductMenu'
    },
    initialize: function initialize() {
      var CustomMenu = UIKit.Menu.extend({
        template: Templates.IRB['menu.app.header'],
        attributes: {},
        className: UIKit.Menu.prototype.className + ' common-header',
        internalViews: {
          title: UIKit.Header.extend({
            tagName: 'h1',
            className: UIKit.Header.prototype.className + ' accessibility-text'
          })
        },
        options: {
          logoHref: staticRoot + '/#dashboard',
          logoLinkText: p('App.Logo.Link.Text')
        }
      });
      this.productSwitcher = new Backbone.Collection();
      this.app.topMenu = this.topMenu = new CustomMenu({
        fixed: true,
        size: 'large'
      });
      this.app.productMenu = this.productMenu = new ProductNavigationMenu();
      this.distractionFreeMode = true;
      this.setupTopMenu();
      this.initializeMenuResponsive();
    },
    initializeMenuResponsive: function initializeMenuResponsive() {
      var self = this;
      enquire.register('screen and (max-height: 740px), (max-width: 768px)', {
        match: function match() {
          self.setSmallScreenMode(true);
        },
        unmatch: function unmatch() {
          self.setSmallScreenMode(false);
        }
      });
    },
    onUserProducts: function onUserProducts(products) {
      this.setupProductSwitcher(products);
    },
    onAuthenticated: function onAuthenticated() {
      this.productMenu.setupProductMenu();
      this.setDistractionFreeMode(true);
    },
    getTopMenu: function getTopMenu() {
      return this.topMenu;
    },
    getProductMenu: function getProductMenu() {
      return this.productMenu;
    },
    setMenuTitle: function setMenuTitle(value) {
      this.topMenu.title.text = value;
    },
    getMenuTitle: function getMenuTitle() {
      return this.topMenu.title.text;
    },
    onChangeSmallScreen: function onChangeSmallScreen(isSmallScreen) {
      if (isSmallScreen) {
        this.app.storage.set('DESKTOP_DISTRACTION_MODE', this.getDistractionFreeMode());
        this.setDistractionFreeMode(true);
      } else {
        this.setDistractionFreeMode(this.app.storage.get('DESKTOP_DISTRACTION_MODE'));
      }
    },
    onChangeDistractionFreeMode: function onChangeDistractionFreeMode(isDistractionFreeMode) {
      this.app.storage.set(this.app.config.DISTRACTION_FREE_FIELD, isDistractionFreeMode);
      this.doMenuResize();
    },
    toggleDistractionFreeMode: function toggleDistractionFreeMode() {
      this.setDistractionFreeMode(!this.distractionFreeMode);
      return this;
    },
    setSmallScreenMode: function setSmallScreenMode(value) {
      this.smallScreenMode = value;
      this.channel.trigger('change:smallScreenMode', this.smallScreenMode);
      return this;
    },
    getSmallScreenMode: function getSmallScreenMode() {
      return this.smallScreenMode;
    },
    setDistractionFreeMode: function setDistractionFreeMode(value) {
      this.distractionFreeMode = !!value;
      this.channel.trigger('change:distractionFreeMode', this.distractionFreeMode);
      return this;
    },
    getDistractionFreeMode: function getDistractionFreeMode() {
      return this.distractionFreeMode;
    },
    doMenuResize: function doMenuResize() {
      var leftPagePadding = '',
        topPagePadding = '120px';
      if (this.distractionFreeMode) {
        leftPagePadding = '0';
      } else {
        leftPagePadding = '210px';
      }
      this.topMenu.$el.css('padding-left', leftPagePadding);
      this.topMenu.title.$el.parent().css('padding-left', leftPagePadding);
      this.app.layout.content;
      this.channel.trigger('resize:menu', {
        top: topPagePadding,
        left: leftPagePadding
      });
    },
    setupProductSwitcher: function setupProductSwitcher(products) {
      var productSwitcher = this.productSwitcher;
      var hostname = 'https://' + products.first().get('hostname');
      productSwitcher.add({
        text: p('App.Nav.ProductSwitcher.HomePage.Text'),
        link: hostname
      });
      products.forEach(function (product) {
        var name = product.get('name');
        if (name !== 'IRB') {
          if (product.get('instanceUrl') !== null && product.get('instanceUrl') !== '') {
            productSwitcher.add({
              text: product.get('name'),
              link: product.get('instanceUrl')
            });
          } else {
            productSwitcher.add({
              text: product.get('name'),
              link: hostname + '/' + product.get('name').toLowerCase()
            });
          }
        }
      });
    },
    setupTopMenu: function setupTopMenu() {
      var oneLogin = Session.isOneLogin();
      var roleDropdown = this.app.request('roleDropdown');
      var userDropdown = this.app.request('userDropdown');
      var productSwitcher = this.buildProductSwitcher();
      productSwitcher.$el.addClass('product-switcher');
      this.topMenu.add(roleDropdown, true).add(this.channel.request('build:notification:dropdown'), true);
      if (oneLogin) {
        this.topMenu.add(productSwitcher, true);
      }
      ;
      this.topMenu.add(userDropdown, true);
    }
  }, "getTopMenu", function getTopMenu() {
    return this.topMenu;
  }), "buildProductSwitcher", function buildProductSwitcher() {
    var productSwitcherDropdown = new ProductsDropdown({
      iconRight: false,
      icon: 'pony-square',
      mode: 'button',
      collection: this.productSwitcher,
      childBindings: {
        text: 'text',
        icon: 'icon',
        image: 'image',
        collection: 'children',
        value: 'value',
        description: 'description',
        link: 'link'
      }
    });
    this.listenTo(this.channel, 'authenticated', function (user) {
      productSwitcherDropdown.text = p('App.Nav.ProductSwitcher');
    }).listenTo(productSwitcherDropdown, 'before:add:child', function (view) {
      view.menuDirection = 'left';
    }).listenTo(productSwitcherDropdown, 'change:value', function (view, model) {
      if (model && model.has('action')) {
        this.channel.request(model.get('action'));
      }
    });
    productSwitcherDropdown.on("add:child", function (event) {
      $(event.el).attr("role", "menuitem");
    });
    return productSwitcherDropdown;
  }));
  module.exports = AppMenuService;
});

